import { render } from "./Sonstiges.vue?vue&type=template&id=6da48ac3&scoped=true"
import script from "./Sonstiges.vue?vue&type=script&lang=js"
export * from "./Sonstiges.vue?vue&type=script&lang=js"

import "./Sonstiges.vue?vue&type=style&index=0&id=6da48ac3&lang=stylus&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da48ac3"]])

export default __exports__